/**
 * MSAL (Microsoft Authentication Library) configuration.
 * Uses Auth Code + PKCE flow for SPA authentication.
 *
 * @module config/msalConfig
 */

import { Configuration, LogLevel } from '@azure/msal-browser';
import { config } from './index';

export const msalConfig: Configuration = {
  auth: {
    clientId: config.azureClientId,
    authority: `https://login.microsoftonline.com/${config.azureTenantId}`,
    redirectUri: `${window.location.origin}/signin`,
    postLogoutRedirectUri: `${window.location.origin}/signin`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: config.isDevelopment ? LogLevel.Warning : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
        else if (level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
    },
  },
};

/** Scopes requested during login redirect. */
export const loginRequest = {
  scopes: config.azureApiScope ? [config.azureApiScope] : [],
};

/** Scopes requested when acquiring an access token for the API. */
export const tokenRequest = {
  scopes: config.azureApiScope ? [config.azureApiScope] : [],
};
